import { useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

interface YearDropdownProps {
  onYearChange?: (year: string) => void;
  initialValue?: string;
}

const years = ['2022-2023', '2023-2024', '2024-2025'];

const YearDropdown: React.FC<YearDropdownProps> = ({ onYearChange, initialValue }) => {
  const [year, setYear] = useState(initialValue);

  const handleChange = (event: SelectChangeEvent) => {
    setYear(event.target.value as string);
    if (onYearChange) {
      onYearChange(event.target.value as string);
    }
  };
  return (
    <FormControl fullWidth>
      <InputLabel id="year-select-label">Year</InputLabel>
      <Select labelId="year-select-label" id="year-select" value={year} label="Year" onChange={handleChange} sx={{ width: 150, height: 40 }}>
        {years.map((yearOption) => (
          <MenuItem key={yearOption} value={yearOption}>
            {yearOption}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

YearDropdown.propTypes = {
  onYearChange: PropTypes.func,
  initialValue: PropTypes.string,
};

export default YearDropdown;
